import { createContext, useContext } from "react";

export interface SidebarMenuContextValue {
  /** Whether the sidebar is in icon-only collapsed mode. */
  collapsed: boolean;
}

/**
 * Context carrying the collapsed flag from the `SidebarMenu` root down to
 * every descendant `SidebarNavItem` and `SidebarMenu.Section`.
 *
 * Defined here (in the molecule) so `SidebarNavItem` owns the shape of the
 * context it consumes. The organism imports the Provider from here.
 */
export const SidebarMenuContext = createContext<SidebarMenuContextValue>({
  collapsed: false,
});

/** Read the current sidebar collapse state. Defaults to expanded when used
 *  outside a `SidebarMenu`. */
export const useSidebarMenuContext = (): SidebarMenuContextValue => useContext(SidebarMenuContext);
